import { IUserHistoryConflict } from '../models/user-activity.model';

export interface IUserActivityConflictTooltip {
  key: string;
  params: Record<string, string>;
}

export function getUserActivityConflictTooltip(
  item?: IUserHistoryConflict | null
): IUserActivityConflictTooltip | null {
  if (!item?.isConflicted) {
    return null;
  }

  const names = (item.conflictedDepartmentNames ?? []).filter((name) => !!name);
  if (names.length === 1) {
    return {
      key: 'activityConflictInDepartment',
      params: { department: names[0] },
    };
  }

  if (names.length > 1) {
    return {
      key: 'activityConflictInDepartments',
      params: { departments: names.join(', ') },
    };
  }

  return { key: 'activityConflict', params: {} };
}
